<template>
  <div v-if="user">
    <section class="hero">
      <div class="hero-body">
        <div class="container">
          <router-link
            class="title"
            :to="{name: 'UserList'}"
          >
            Users
          </router-link>
        </div>
      </div>
    </section>

    <section class="container loading-data">
      <div class="columns">
        <div class="column">
          <div class="box">
            <table class="table is-fullwidth">
              <thead>
                <tr>
                  <th class="is-3">
                    Fields
                  </th>
                  <th>Values</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <th>Email</th>
                  <td>{{ user.email }}</td>
                </tr>
                <tr>
                  <th>Reset Password Sent At</th>
                  <td>{{ user.resetPasswordSentAt }}</td>
                </tr>
                <tr>
                  <th>Updated At</th>
                  <td>{{ user.updatedAt }}</td>
                </tr>
                <tr>
                  <th>Created At</th>
                  <td>{{ user.createdAt }}</td>
                </tr>
              </tbody>
            </table>

            <nav class="level is-mobile">
              <div class="level-left" />
              <div class="level-right" />
            </nav>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { showMixin } from '@/mixins/crud/pagination'

  export default {
    name: 'User',
    mixins: [ showMixin('user') ],
    props: {
      id: {
        type: Number,
        default: undefined
      }
    },
    computed: {
      ...mapGetters({
        byId: 'users/byId'
      }),
      user() {
        return this.byId(this.id)
      }
    },
    mounted() {
      let that = this
      this.loadById(this.id).then(function(response){
        if (!response) {
          that.$router.push({name: 'NotFound'})
        }
      })
    },
    methods: {
      ...mapActions({
        loadById: 'users/loadById',
      }),
    },
  }
</script>

<style lang="scss" scoped>
</style>
